<design-slide-up-card #card [isCardOpen]="!!isCardOpen" [displayBackground]="true" [title]="data.title"
  [roleDialog]="true"
  [focusInitialOnHeaderBack]="false"
  (onHeaderButtonClick)="closeCard()" [icon]="iconName" class="route-planner-autocomplete">
  <div class="flex flex-col py-4 px-2 gap-8 min-h-0 flex-1" [class]="direction">
    <!--
      a11y: WAI-ARIA combobox-autocomplete-list pattern.
      Input exposes role="combobox" + aria-controls/expanded/activedescendant via comboboxRole inputs.
      Lines list below is the listbox with role="option" rows; arrow keys handled on the input.
    -->
    <mot-input #input [formControl]="formControl" [displayErrors]="false" appearance="fill" [icon]="
            input.formControl?.value?.length >= autoCompleteMinChar
            ? 'close'
            : null
            " iconClass="text-xl cursor-pointer" prefixIcon="search" prefixIconClass="text-xl"
      (onIconClick)="clearValue()" [iconButtonAriaLabel]="clearText" [placeholder]="inputPlaceholder"
      [ariaLabel]="inputPlaceholder"
      [comboboxRole]="true"
      [comboboxControlsId]="listboxId"
      [comboboxExpanded]="isListboxExpanded"
      [comboboxActiveDescendant]="activeOptionId"
      (keydown)="onComboboxKeydown($event)"
      class="bg-transparent w-full leading-loose !text-default" [dir]="direction" [attr.cdkFocusInitial]="true"/>

      @if (results$ | async; as lines) {
        @if (
          formControl.value?.length >= autoCompleteMinChar &&
          (emptyResults$ | async) == true) {
          <div class="px-2">
            <p class="m-0 text-wrap">
              {{noResultsText}} {{forText}} {{ formControl.value }}
            </p>
          </div>
        } @else {
          <ul
            [id]="listboxId"
            role="listbox"
            [attr.aria-label]="inputPlaceholder"
            tabindex="-1"
            class="list-none m-0 p-0 flex flex-col flex-1 gap-2 overflow-y-auto"
            (focus)="onListboxContainerFocus($event)"
            (keydown)="onListboxKeydown($event)">
            @for (line of lines; track line; let i = $index) {
              <li
                [id]="getOptionId(i)"
                role="option"
                tabindex="-1"
                [attr.aria-selected]="activeOptionIndex === i ? 'true' : 'false'"
                class="rounded cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
                [class.bg-primary-50]="activeOptionIndex === i"
                (mousedown)="$event.preventDefault()"
                (focus)="onOptionFocus(i)"
                (click)="chooseValue(line.value, !!data.saveResultToStorage)">
                <app-line-auto-complete-result
                  [line]="line.value"
                  [isPointer]="false"
                  (onAgencyClick)="openAgencyContact(false, $event)" />
              </li>
            }
          </ul>
        }
      }
    </div>

  </design-slide-up-card>
